/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Neetesh Bhati",
  title: "Hi, I'm Neetesh",
  subTitle: emoji(
    "I build scalable cloud platforms and lead teams that turn complex systems into reliable products."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1N_foJsXD2LF5_19TbToYQYL7RAs_EIwT/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/neeteshbhati",
  linkedin: "https://www.linkedin.com/in/neeteshbhati/",
  gmail: "neeteshbhati@gmail.com",
  facebook: "https://www.facebook.com/neeteshbhati",
  // medium: "https://medium.com/@neeteshbhati",
  // stackoverflow: "https://stackoverflow.com/users/6160100/neetesh-bhati",
  instagram: "https://www.instagram.com/neeteshbhati/",
  twitter: "https://twitter.com/neeteshbhati",
  // gitlab: "https://gitlab.com/neeteshbhati",
  // You can remove any of the links above if you don't have any account
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "I build and lead scalable cloud platforms.",
  skills: [
    emoji(
      "⚡ Design distributed systems that handle large-scale, data-intensive workloads"
    ),
    emoji("⚡ Lead engineers through architecture, delivery, and quality improvements"),
    emoji(
      "⚡ Turn complex infrastructure into reliable, high-impact products"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "javascript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "node-js",
      fontAwesomeClassname: "fab fa-node-js"
    },
    {
      skillName: "react",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "azure",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "github",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "linux",
      fontAwesomeClassname: "fab fa-linux"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Birla Institute of Technology and Science – Dubai",
      logo: require("./assets/images/bitsLogo.png"),
      subHeader: "Master of Engineering in Software Systems",
      duration: "August 2021 - July 2023",
      desc: "Focused on core computer science fundamentals including data structures, algorithms, operating systems, and distributed systems, graduating with academic distinction (CGPA 9.80)",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Birla Institute of Technology and Science – Dubai",
      logo: require("./assets/images/bitsLogo.png"),
      subHeader: "Bachelor of Engineering in Computer Science",
      duration: "August 2017 - July 2021",
      desc: "Advanced study in large-scale software architecture, cloud computing, and system design, graduating with high distinction (CGPA 9.90)",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Cloud-Native Distributed Systems", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend & Systems Engineering",
      progressPercentage: "80%"
    },
    {
      Stack: "Desktop & Systems-Level Development",
      progressPercentage: "50%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Software Engineer",
      company: "Esri",
      companylogo: require("./assets/images/esriLogo.png"),
      date: "Jan 2026 – Present",
      desc: "Led architecture and technical direction for a core cloud platform area, scaling distributed systems while guiding engineers and raising engineering standards.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "Software Engineer II",
      company: "Esri",
      companylogo: require("./assets/images/esriLogo.png"),
      date: "Jan 2024 – Dec 2025",
      desc: "Owned end-to-end delivery of critical services and infrastructure improvements, driving measurable gains in performance and release efficiency.",
    },
    {
      role: "Software Engineer I",
      company: "Esri",
      companylogo: require("./assets/images/esriLogo.png"),
      date: "Sep 2021 – Dec 2023",
      desc: "Built and shipped production microservices and desktop features while ramping up on large-scale cloud and distributed systems.",
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "A showcase of complex systems and scalable solutions I have worked on",
  projects: [
    {
      image: require("./assets/images/imageDedicatedLogo.png"),
      projectName: "ArcGIS Image Dedicated",
      projectDesc: "A cloud-native SaaS platform that enables large-scale processing and analysis of imagery and raster data across AWS and Azure environments.",
      footerLink: [
        {
          name: "Know More",
          url: "https://www.esri.com/en-us/arcgis/products/arcgis-image/options/dedicated"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/orientedImageryLogo.png"),
      projectName: "Oriented Imagery in ArcGIS Pro",
      projectDesc: "A capability that allows users to manage, visualize, and explore non-nadir imagery within a map context by using camera metadata to relate image pixels to ground locations.",
      footerLink: [
        {
          name: "Know More",
          url: "https://www.esri.com/arcgis-blog/products/arcgis/imagery/introducing-oriented-imagery"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "A collection of milestones and credentials that validate my technical expertise and growth",

  achievementsCards: [
    {
      title: "UAE Golden Residency",
      subtitle:
        "Awarded long-term residency by the UAE government in recognition of exceptional academic and extracurricular achievements.",
      image: require("./assets/images/goldenVisaLogo.webp"),
      imageAlt: "UAE Golden Visa",
      footerLink: [
        {
          name: "Know More",
          url: "https://u.ae/en/information-and-services/visa-and-emirates-id/residence-visas/golden-visa"
        }
      ]
    },
    {
      title: "Hack on Health Hackathon Winner",
      subtitle:
        "Won 1st place among 100+ participants for developing an innovative digital health solution in a competitive government-backed hackathon.",
      image: require("./assets/images/hackOnHealthLogo.jpg"),
      imageAlt: "Hack on Health",
      footerLink: [
        {
          name: "Blog Post",
          url: "https://www.bits-pilani.ac.in/sed-do-eiusmod-tempor-incididunt-ut-labore-et-dolore-magna-aliqua-2-2-2-2"
        },
        {
          name: "News Update",
          url: "https://www.doh.gov.ae/en/news/Department-of-Health-Abu-Dhabi-calls-on-innovators-and-experts-to-participate"
        }
      ]
    },

    {
      title: "Professional Scrum Master 1",
      subtitle: "Certified skill in facilitating Scrum ceremonies and fostering self-organizing teams to deliver high-quality increments.",
      image: require("./assets/images/scrumMasterLogo.png"),
      imageAlt: "Scrum PSM 1",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/86f0c5f8-8521-4ed4-89b0-017aac43488d"
        },
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Let’s build something great together, do reach out and say hello",
  number: "+971554524400",
  email_address: "neeteshbhati@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "neeteshbhati", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
